<div>
  <span *ngIf="verified"><fa-icon [icon]="['fas', 'check']" class="check" /></span>
  <div *ngIf="!verified && rejected" class="rejected"><strong>REJECTED</strong></div>
  <span [ngClass]="{ rejected: !verified && rejected }">
    <ng-container *ngIf="submission">
      {{ submission.submittedAt | date: 'MM/dd/yyyy' }} by {{ submission.submittedBy.fullName }}
    </ng-container>
  </span>
</div>
